<template>
  <div class="other-container-l">

    <div class="smaller-menu-tabs">
      <label for="tab1" class="filter-label" :class="{'is-selected': (tab == 'personal-information')}" v-on:click="tab = 'personal-information'">{{$t('PERSONALDATA')}}</label>
      <label for="tab2" class="filter-label" :class="{'is-selected': (tab == 'contact-information')}" v-on:click="tab = 'contact-information'">{{$t('CONTACTDATA')}}</label>
      <label for="tab3" class="filter-label" :class="{'is-selected': (tab == 'user-information')}" v-on:click="tab = 'user-information'">{{$t('USERDATA')}}</label>
      <img class="close-modal" src="../../assets/img/close.svg">
    </div>

    <div class="pages-left-container">
      <div class="content-container pages-container" v-if="!success">

          <!-- PERSONAL INFORMATION -->
          <div  v-if="tab == 'personal-information'">
              <div class="withdrawal-online">
                  <h2>{{$t('REGISTERONLINEACCOUNT')}}</h2>
                  <p>{{$t('REGISTERONLINEACCOUNTDISCLAIMERONE')}}</p>

                  <hr class="content-line mb-xlg mt-xlg">

                  <div class="input-box">
                    <inputvalidation :formerror="formError" name="name">
                        <label>{{ $t('NAME')}}</label>
                        <input type="text" class="input-text mr-lg mb-lg"
                        v-model="form.name"
                        v-bind:placeholder="$t('NAME')">
                    </inputvalidation>
                    <inputvalidation :formerror="formError" name="surname">
                        <label>{{ $t('SURNAME')}}</label>
                        <input class="input-text mr-lg mb-lg"
                        v-model="form.surname"
                        v-bind:placeholder="$t('SURNAME')" type="text">
                    </inputvalidation>
                    <inputvalidation :formerror="formError" name="userEmail">
                        <label>{{ $t('EMAIL')}}</label>
                        <input class="input-text mr-lg mb-lg"
                        v-model="form.userEmail"
                        v-bind:placeholder="$t('EMAIL')" type="email"
                        ref="usernameinput">
                    </inputvalidation>
                    <inputvalidation :formerror="formError" name="repeatUserEmail">
                        <label>{{ $t('REPEATEMAIL')}}</label>
                        <input class="input-text mr-lg mb-lg"
                        v-model="form.repeatUserEmail"
                        v-bind:placeholder="$t('REPEATEMAIL')" type="email"
                        ref="usernameinput">
                    </inputvalidation>
                  </div>

                  <form action="" class="pages-buttons-form">
                  <!-- a href="" class="button button-grey-first mr-lg button-cancel">Odustani</a -->
                  <a href="#" v-on:click.stop="checkRegisterDataStepOne('contact-information')" class="button button-blue button-continue">{{$t('CONTINUE')}}</a>
                  </form>
              </div>
          </div>

          <!-- CONTACT INFORMATION -->
          <div  v-if="tab == 'contact-information'">
              <div class="withdrawal-online">
                  <h2>{{$t('REGISTERONLINEACCOUNT')}}</h2>
                  <p>{{$t('REGISTERONLINEACCOUNTDISCLAIMERTWO')}}</p>

                  <hr class="content-line mb-xlg mt-xlg">

                  <div class="input-box">
                    <inputvalidation :formerror="formError" name="oibNum">
                        <label>{{ $t('OIBNUM')}}</label>
                        <input class="input-text mr-lg mb-lg"
                        v-model="form.oibNum"
                        v-bind:placeholder="$t('OIBNUM')" type="text">
                    </inputvalidation>
                    <inputvalidation :formerror="formError" name="dateOfBirth">
                        <label>{{ $t('DATEOFBIRTH')}}</label>
                        <input class="input-text mr-lg mb-lg"
                        v-model="form.dateOfBirth"
                        v-bind:placeholder="$t('DATEOFBIRTH')" type="text">
                    </inputvalidation>
                    <inputvalidation :formerror="formError" name="address">
                        <label>{{ $t('ADDRESS')}}</label>
                        <input class="input-text mr-lg mb-lg"
                        v-model="form.address"
                        v-bind:placeholder="$t('ADDRESS')" type="text">
                    </inputvalidation>
                    <inputvalidation :formerror="formError" name="city">
                        <label>{{ $t('CITY')}}</label>
                        <input class="input-text mr-lg mb-lg"
                        v-model="form.city"
                        v-bind:placeholder="$t('CITY')" type="text">
                    </inputvalidation>
                    <inputvalidation :formerror="formError" name="country">
                        <label>{{ $t('COUNTRY')}}</label>
                        <input class="input-text mr-lg mb-lg"
                        v-model="form.country"
                        v-bind:placeholder="$t('COUNTRY')" type="text">
                    </inputvalidation>
                    <inputvalidation :formerror="formError" name="phone">
                        <label>{{ $t('PHONE')}}</label>
                        <input class="input-text mr-lg mb-lg"
                        v-model="form.phone"
                        v-bind:placeholder="$t('PHONE')" type="text">
                    </inputvalidation>
                  </div>

                  <form action="" class="pages-buttons-form">
                  <a href="#" v-on:click="tab = 'personal-information'" class="button button-grey-first mr-lg button-cancel">{{$t('BACK')}}</a>
                  <a href="#" v-on:click.stop="checkRegisterDataStepTwo('user-information')" class="button button-blue button-continue">{{$t('CONTINUE')}}</a>
                  </form>
              </div>
          </div>

          <!-- USER INFORMATION -->
          <div  v-if="tab == 'user-information'">
              <div class="user-information withdrawal-online">
                  <h2>{{$t('REGISTERONLINEACCOUNT')}}</h2>
                  <p>{{$t('REGISTERONLINEACCOUNTDISCLAIMERTHREE')}}</p>

                  <hr class="content-line mb-xlg mt-xlg">

                  <div class="input-box">
                    <inputvalidation :formerror="formError" name="username">
                        <label>{{ $t('USERNAME')}}</label>
                        <input class="input-text mr-lg mb-lg"
                        v-model="form.username"
                        v-bind:placeholder="$t('USERNAME')" type="text"
                        ref="usernameinput">
                    </inputvalidation>
                    <inputvalidation :formerror="formError" name="password">
                        <label>{{ $t('PASSWORD')}}</label>
                        <input class="input-text mr-lg mb-lg"
                        v-model="form.password"
                        v-bind:placeholder="$t('PASSWORD')" type="password">
                    </inputvalidation>
                    <inputvalidation :formerror="formError" name="repeatpassword">
                        <label>{{ $t('REPEATPASSWORD')}}</label>
                        <input class="input-text mr-lg mb-lg"
                        v-model="form.repeatpassword"
                        v-bind:placeholder="$t('REPEATPASSWORD')" type="password">
                    </inputvalidation>
                </div>

                  <hr class="content-line mb-xlg mt-xlg">

                  <input type="checkbox" class="input-checkbox full" v-model="form.agreeToTerms"><span class="checkmark"></span>
                    <p>{{$t('REGISTRATIONAGREEMENTDISCLAIMER')}}</p>

                  <form action="" class="pages-buttons-form">
                  <a href="#" v-on:click="tab = 'contact-information'" class="button button-grey-first mr-lg button-cancel">{{$t('BACK')}}</a>
                  <a href="#" @click.stop="register" class="button button-blue button-continue">{{$t('FINISHREGISTRATION')}}</a>
                  <p class="text-danger" v-html="errors"></p>
                  </form>
              </div>
          </div>

      </div>
      <div class="content-container pages-container" v-else>
          <p class="text-danger">{{$t('REGISTRATIONSUCCESFULLDISCLAIMER')}}</p>
      </div>
    </div>

    <div class="pages-promotions-sidebar registration-sidebar">
        <div class="need-help">
            <h3>{{$t('HAVINGISSUESCONTACTUS')}}</h3>
            <p><img src="../../assets/img/chat.svg"> Live chat</p>
            <p><img src="../../assets/img/chat.svg"> 823 9237 323</p>
            <p><img src="../../assets/img/chat.svg"> support@demobet.com</p>
            <p><img src="../../assets/img/help.svg"> Postavke privatnosti</p>
        </div>
        <div class="promo-images">
        <img src="../../assets/img/promotion-1.png">
        <img src="../../assets/img/promotion-3.png">
        </div>
    </div>

  </div>
</template>

<script>
import {
    mapGetters,
} from 'vuex';
import Api from '../api/Player';

export default {
    name: 'Registration',
    data()
    {
        return {
            tab: 'personal-information',
            form: {
                username: '',
            },
            formError: {},
            success: false,
            errors: '',
        };
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
        ]),
    },
    created()
    {
        const me = this;

        me.$nextTick(() =>
        {
            if (me.$refs.usernameinput)
            {
                me.$refs.usernameinput.focus();
            }
        });
    },
    methods:
    {
        async checkRegisterDataStepOne(tabToMoveTo)
        {
            const me = this;

            me.errors = '';

            const data = await Api.checkRegisterDataStepOne(me.form);

            if (data.error)
            {
                me.formError = data;
            }
            else
            {
                me.tab = tabToMoveTo;
            }
        },
        async checkRegisterDataStepTwo(tabToMoveTo)
        {
            const me = this;

            me.errors = '';

            const data = await Api.checkRegisterDataStepTwo(me.form);

            if (data.error)
            {
                me.formError = data;
            }
            else
            {
                me.tab = tabToMoveTo;
            }
        },
        async register()
        {
            const me = this;

            me.errors = '';

            const data = await Api.register(me.form);

            if (data.error)
            {
                me.formError = data;

                if (data.errors != null)
                {
                    for (const error of data.errors)
                    {
                        switch (error.code)
                        {
                        case 'field_is_required':
                        case 'field_to_short':
                        case 'field_wrong_data_type':
                            me.errors += `<br>${error.code.toUpperCase()}_${error.params.field.toUpperCase()}`;
                            break;
                        default:
                            me.errors += `<br>${error.code.toUpperCase()}`;
                        }
                    }
                }
            }
            else
            {
                me.success = true;
            }
        },
    },
};
</script>
